import PortalClienteService from "services/bases/PortalClienteService";

class ContratoFinanceiroService extends PortalClienteService{
    async ListarPorDireito(direitoid){
        return await this.get(`contratosfinanceiros/ListarContratosPorDireito?direitoId=${direitoid}`)
    }
    async ListarPorContato(contatoId){
        return await this.get(`contratosfinanceiros/ListarContratosPorContato/${contatoId}`)
    }
}

export default new ContratoFinanceiroService();